import baseAPI from '@/api';
import { Success } from '@/models/success';
import { AxiosResponse } from 'axios';

export async function fetchLogout(): Promise<Success> {
  const response: AxiosResponse<Success> = await baseAPI.post<Success>('iam/logout');

  return response.data;
}
